// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__ioXoi","content":"GlobalSearch_content__2JLx1"};